<template>
  <div class="bg-surface rounded-xl p-4 max-w-[58rem] mx-auto mt-6">
    <div v-if="props.resource.fileUrl">
      <img
        v-if="isUrlFirebaseFile(props.resource.fileUrl)"
        :src="props.resource.fileUrl"
        :alt="$t('content.resource-alt')"
        class="w-full object-cover rounded-lg aspect-[8/5]"
      />

      <iframe
        v-else-if="isEmbeddedVideoUrl(props.resource.fileUrl)"
        class="w-full aspect-video rounded-lg"
        :src="props.resource.fileUrl"
      />

      <Btn
        v-else
        :size="BtnSize.MD"
        :variant="BtnVariant.FILLED"
        :color="BtnColor.SECONDARY"
        :to="props.resource.fileUrl"
        target="_blank"
      >
        View Resource
      </Btn>
    </div>

    <div class="mt-10 prose max-w-full" v-html="props.resource.description" />

    <div v-if="props.resource.displayCtaButton" class="text-center mt-12">
      <Btn
        :size="BtnSize.LG"
        :variant="BtnVariant.FILLED"
        :color="BtnColor.PRIMARY"
        :to="props.resource.ctaButtonUrl"
        target="_blank"
        @click="onCtaButtonClick"
      >
        {{ props.resource.ctaButtonText }}
      </Btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Btn, BtnSize, BtnColor, BtnVariant } from '~/components/btn';
import { isEmbeddedVideoUrl, isUrlFirebaseFile } from '../../content.utils';
import { apiMarkContentCtaButtonClicked, ContentDto } from '~/api/contents';

type Props = {
  hubSlug: string;
  contentSlug: string;
  resource: NonNullable<ContentDto['resource']>;
};
const props = defineProps<Props>();

const onCtaButtonClick = () => {
  apiMarkContentCtaButtonClicked(props.hubSlug, props.contentSlug);
};
</script>
